module.exports = __webpack_public_path__ + "img/37.2521c87a.svg";